// Package imports:
import React from 'react';
// Component imports:
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

interface IOwnProps {
    showModal: boolean,
    closeModal(): void
}
type Props = IOwnProps;

class About extends React.Component<Props> {
    render() {
        return (
            <Modal
                show={this.props.showModal}
                onHide={() => this.props.closeModal()}
            >
                <Modal.Header>
                    <h4 className='modal-title'>About Sigti</h4>
                </Modal.Header>
                <Modal.Body>
                    <p>Sigti is a market monitoring and reviewing system.</p>
                    <p>The user has access to all tick data and is able to browse through the data, one symbol at a time. By selecting a given timestamp and symbol, the user can see the order book at that given time and that way is able to travel through the trading day while reviewing and commenting on specific points of interest.</p>
                    <p>A set of defined alerts are configurable by the user. Each alert references a given timestamp and in most cases a product symbol. The alert can be reviewed by selecting the timestamp. The alerts can be reviewed, escalated or closed by the user.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant='dark'
                        onClick={() => this.props.closeModal()}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default About;
